export default __webpack_public_path__ + "static/media/snyk.c3e28a60.svg";